import { A4_HEIGHT_72DPI, A4_WIDTH_72DPI } from "../constants";

export const getCommonPageVars = (zoom) => ({
  "--doc-current-zoom": zoom,
  "--doc-a4-width": `${A4_WIDTH_72DPI}px`,
  "--doc-a4-height": `${A4_HEIGHT_72DPI}px`,
});
